// removed by extract-text-webpack-plugin
module.exports = {"Menu":"Registration__Menu___12zup","Additional":"Registration__Additional___rfbev","Title":"Registration__Title___3yjSq","Checkboxes":"Registration__Checkboxes___oGT-f","Button":"Registration__Button___eFnqN","FirstColumn":"Registration__FirstColumn___1HP8Q","SecondColumn":"Registration__SecondColumn___3DdAq","Checkbox":"Registration__Checkbox___3yrrD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/FiltersBar/Filters/Registration/Registration.scss
// module id = 1344
// module chunks = 0